<mat-card>
  <form [formGroup]="ward_register_form">

    <div class="form-group">
      <label>Constituency <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
      <select class="form-control dropdown_box" formControlName="constituency_id">
        <option *ngFor="let constituency of constituencies" [value]="constituency['id']">{{constituency['name']}}
        </option>
      </select>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='name'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Number <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="number" class="form-control code_box" formControlName='ward_number'>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Corporation zone <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='corporation_zone'>
            <option *ngFor="let corp_zone of corp_zones" [value]="corp_zone['id']">{{corp_zone['name']}} </option>
          </select>
        </div>
      </div>
    </div>

    <button mat-raised-button color="primary" (click)="registerWard()" [disabled]="!ward_register_form.valid"
      class="capitalize">{{action}}</button>
  </form>
</mat-card>
